if (typeof document === "undefined") return;
var createStylesheet = function (
	chunkId, fullhref, oldTag, resolve, reject
) {
	var linkTag = document.createElement("link");

linkTag.rel = "stylesheet";

linkTag.type = "text/css";

if (__webpack_require__.nc) {
  linkTag.nonce = __webpack_require__.nc;
}
linkTag.href = fullhref;

	var onLinkComplete = function (event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	if (oldTag) {
            oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
          } else {
            document.head.appendChild(linkTag);
          }
	return linkTag;
}
var findStylesheet = function (href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for (var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if (dataHref) {
			dataHref = dataHref.split('?')[0]
		}
		if (tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}

	var existingStyleTags = document.getElementsByTagName("style");
	for (var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if (dataHref === href || dataHref === fullhref) return tag;
	}
}

var loadStylesheet = function (chunkId) {
	return new Promise(function (resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if (findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	})
}

// object to store loaded CSS chunks
var installedCssChunks = {
	"index": 0,

};

__webpack_require__.f.miniCss = function (chunkId, promises) {
	var cssChunks = {
"src_extensions_cornerstone-dicom-seg_index_tsx-src_extensions_cornerstone_components_DicomUpl-a8462a": 1,
"src_extensions_cornerstone_Viewport_OHIFCornerstoneViewport_css-src_extensions_cornerstone_Vi-12ff24": 1,
"src_extensions_cornerstone_components_DicomUpload_DicomUpload_css": 1,
"src_extensions_dicom-microscopy_DicomMicroscopyViewport_tsx": 1,
"src_extensions_dicom-microscopy_index_tsx-src_extensions_cornerstone_components_DicomUpload_D-70d9c1": 1,
"src_extensions_dicom-pdf_viewports_OHIFCornerstonePdfViewport_tsx": 1,
"src_extensions_measurement-tracking_index_tsx-src_extensions_cornerstone_components_DicomUplo-b7c755": 1,
"src_extensions_measurement-tracking_viewports_TrackedCornerstoneViewport_tsx-src_extensions_c-fe272e": 1,
"src_extensions_remote-render_index_ts": 1,
"src_extensions_tmtv_index_tsx-src_extensions_cornerstone_components_DicomUpload_DicomUpload_css": 1,

};
	if (installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId])
	else if (installedCssChunks[chunkId] !== 0 && cssChunks[chunkId])
		promises.push(
			installedCssChunks[chunkId] = loadStylesheet(chunkId).then(
				function () {
					installedCssChunks[chunkId] = 0;
				},
				function (e) {
					delete installedCssChunks[chunkId];
					throw e;
				}
			)
		)
}

var oldTags = [];
var newTags = [];
var applyHandler = function (options) {
	return {
		dispose: function () {
			for (var i = 0; i < oldTags.length; i++) {
				var oldTag = oldTags[i];
				if (oldTag.parentNode) oldTag.parentNode.removeChild(oldTag);
			}
			oldTags.length = 0;
		},
		apply: function () {
			for (var i = 0; i < newTags.length; i++) newTags[i].rel = "stylesheet";
			newTags.length = 0;
		}
	}
}
__webpack_require__.hmrC.miniCss = function (chunkIds, removedChunks, removedModules, promises, applyHandlers, updatedModulesList) {
	applyHandlers.push(applyHandler);
	chunkIds.forEach(function (chunkId) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		var oldTag = findStylesheet(href, fullhref);
		if (!oldTag) return;
		promises.push(new Promise(function (resolve, reject) {
			var tag = createStylesheet(
				chunkId,

				/**
					If dynamically add link tag through dom API and there is already a loaded style link, browsers sometimes treats the new link tag as the same link, and won't fetch the new style.
					Use query to avoid browser cache the link tag, force to re-fetch new style, this is the same strategy as updateCss API, this can happen during lazy compilation
				 */
				`${fullhref}?${Date.now()}`,
				oldTag,
				function () {
					tag.as = "style";
					tag.rel = "preload";
					resolve();
				},
				reject
			);
			oldTags.push(oldTag);
			newTags.push(tag);
		}))
	});
}

__webpack_require__.F.miniCss = (chunkId) => {
  if ((!__webpack_require__.o(installedCssChunks, chunkId) || installedCssChunks[chunkId] === undefined) && /^(src_extensions_(measurement\-tracking_(index_tsx\-src_extensions_cornerstone_components_DicomUplo\-b7c755|viewports_TrackedCornerstoneViewport_tsx\-src_extensions_c\-fe272e)|dicom\-(microscopy_(DicomMicroscopyViewport_tsx|index_tsx\-src_extensions_cornerstone_components_DicomUpload_D\-70d9c1)|pdf_viewports_OHIFCornerstonePdfViewport_tsx)|cornerstone(\-dicom\-seg_index_tsx\-src_extensions_cornerstone_components_DicomUpl\-a8462a|_Viewport_OHIFCornerstoneViewport_css\-src_extensions_cornerstone_Vi\-12ff24|_components_DicomUpload_DicomUpload_css)|remote\-render_index_ts|tmtv_index_tsx\-src_extensions_cornerstone_components_DicomUpload_DicomUpload_css)|index|vendors\-node_modules_pnpm_cornerstonejs_dicom\-image\-loader_4_20_0__cornerstonejs_core_4_20_0_\-738135)$/.test(chunkId)) {
    installedCssChunks[chunkId] = null;

    var link = document.createElement('link');

if (__webpack_require__.nc) {
  link.setAttribute('nonce', __webpack_require__.nc);
}
link.rel = "prefetch";
link.as = "style";
link.href = __webpack_require__.p + __webpack_require__.miniCssF(chunkId);
    document.head.appendChild(link);
  }
};
// no preload